/**
 * TinyMCE self-hosted (version gratuite).
 * Le script est chargé globalement via public/index.html → window.tinymce est disponible.
 * On retourne une valeur non-nulle pour que les composants n'affichent pas l'alerte
 * "Clé TinyMCE manquante", sans avoir besoin de modifier chaque composant.
 */
export const useTinyMceApiKey = () => ({
  apiKey: 'self-hosted' as string,
  isLoading: false,
  error: null,
  refetch: () => {},
});
